import { cofs_update } from "./tournament_cofs_updater.js";
import { countTotalAllDivs } from "../helpers/countTotal.js";
import {betItemFunc} from "../bet/betItemFunc.js";
import { items } from "../helpers/items.js";
import {toFixed} from '../global.js';

(function ($) {

    // Uncheck all item checkboxes inside inventory after page load
    $('#js__items input.item_checkbox_js').prop('checked', false);

    // Set input range value to 0 and trigger change event
    $('input.input-range').val(0).trigger('change');
    $('input.input-range-value').val(0).trigger('change');
    $('input[name="user_betcoin"]').val(0);

    let ignore_countTotalAndProfit = false;
    function countTotalAndProfit() {
        if (ignore_countTotalAndProfit) {
            return;
        }
        countTotalAllDivs();
        let $total_in_bet = $('.js_teams-bet__profit-for:visible');
        let $total_profit = $('.js_teams-bet__profit-get:visible');
        if ($total_in_bet.length == 0) {
            return;
        } else {
            let total_in_bet = parseFloat($('.in_bet:visible .user_items_price').text());
            let $bet_cof = $('.bet-item.active span[data-cof]');
            let cof = parseFloat($bet_cof.data('cof'))
            let total_profit = total_in_bet*cof;
            $total_in_bet.text(toFixed(total_in_bet, 2));
            $total_profit.text(toFixed(total_profit, 2));
            update_buttons_to_bet();
        }
    }

    countTotalAndProfit();
    //click on bet type
    $('.teams-match__item:not(.center) .bet-wrap .bet-item').on('click', function (e) {
        //if has class disabled or active do nothing
        if ($(this).hasClass('disabled') || $(this).hasClass('active')) {
            e.preventDefault();
            if ($(this).hasClass('disabled')) {
                $(this).parent('.bet-wrap').find('input[type="radio"]').prop('checked', false);
            }
            return;
        }
        betItemFunc(this);
        let bet_type = $(this).data('type');
        let bet_title = $(this).data('type_title');
        let bets_count = $(this).data('bets_count');
        let bets_status = $(this).data('status');
        let max_bet = $(this).data('max-bet');
        let score = $(this).data('score');
        let is_classic_bet = !bet_type.includes(`live`);
        let selected_team = $(this).siblings(`input[name=team_${bet_type}]`).val();
        let team1 = $('.teams-match__item-title>b>a')[0].innerText;
        let team2 = $('.teams-match__item-title>b>a')[1].innerText;
        let type_icon_src = $(this).data('type_icon')

        //hide all $('.bet-content[data-type]') and show only one with data-type = $(this).data('type')
        $('.bet-content[data-type]').hide();
        if ($(`.bet-content[data-type="${bet_type}"]`).length != 0) {
            $(`.bet-content[data-type="${bet_type}"]`).show();
        } else {
            $(`.bet-content[data-type="none"]`).show();
        }


        //unchek all checkboxes and check only one with data-type = $(this).data('type')
        $('.teams-match__item .bet-wrap input[type="radio"]').prop('checked', false);

        //check side bet type input
        $(this).parent('.bet-wrap').find('input[type="radio"]').prop('checked', true);

        //check center bet type input
        $(`input#${bet_type}_button`).prop('checked', true);

        //show correct notification block
        $('#tournament__notification_block_6').remove();
        $('#tournament__notification_block_5').remove();
        $('#tournament__notification_block_2').show();


        //fill about div
        let about_div = $('#tournament__notification_block_2');
        about_div.find('.teams-bet__about-title').text(bet_title);

        if (selected_team=='team_1') {
            $('.teams-bet__about-team-name').text(team1);
        } else {
            $('.teams-bet__about-team-name').text(team2);
        }

        about_div.find('.teams-bet__about-icon').hide();
        if (type_icon_src) {
            var img = $(`<img class="teams-bet__about-icon c-important icon to-svg" src="${type_icon_src}">`); 
            about_div.find('.teams-bet__about-icon').replaceWith(img);
            toSVG();
        }
            
        if (score) {
            $('.teams-bet__vs').text(score);
        } else {
            $('.teams-bet__vs').text('VS');
        }

        if (max_bet) {
            $('input.input-range').attr('max', max_bet);
            $('input.input-range-value').attr('max', max_bet);
        }


        update_buttons_to_bet($(this));
        countTotalAndProfit();
    });


    //ignore clicks on disabled or active bet types
    $('.teams-bet__label').on('click', function (e) {
        if ($(this).find('.bet-item.disabled').length) {
            e.preventDefault();
        }
    });


    //items clicks
    $('.block__item').on('click', '.pay__item', function (e) {
        if ($(this).find('input[type=checkbox]').length == 0) {
            return;
        }
        let in_bet_div = $('.form_for_js_in_div .in_bet.bet-content .bet-content-show:visible');
        let user_inventory_div = $('#js__items')
        if ($(this).parents('#js__items').length) {
            //in inventory click move to in_bet
            //if bet is started do nothing
            if ($('.bet-item.active.started').length != 0) {
                return;
            }
            //set hidden input checked true
            $(this).find('input.item_checkbox_js').prop('checked', true);
            in_bet_div.append($(this));
        } else {
            if ($('.bet-item.active.started').length != 0) {
                return;
            }
            //if item was in bet onload do nothing
            if ($(this).find('input.item_checkbox_js').length == 0) {
                return;
            }
            //set hidden input checked false
            $(this).find('input.item_checkbox_js').prop('checked', false);
            //in bet click move to inventory
            user_inventory_div.append($(this));
        }
        countTotalAndProfit();
    });


    //items all in button
    $('.bet-content').on('click', '#all-in', function () {
        if ($('.bet-item.active.started').length != 0) {
            return;
        }
        click_all_in();
    });
    
    function click_all_in() {
        ignore_countTotalAndProfit = true;
        $('#js__items .pay__item:visible').click();
        ignore_countTotalAndProfit = false;
        countTotalAndProfit();
    }

    //cancel bet button
    $('.in_bet').on('click', '.bet-content-cancel', function () {
        if ($('.bet-item.active.started').length != 0) {
            return;
        }
        click_all_items_in_bet();
    });

    function click_all_items_in_bet() {
        ignore_countTotalAndProfit = true;
        $('.in_bet .pay__item').click();
        ignore_countTotalAndProfit = false;
        countTotalAndProfit();
    }

    
    //place bet, update bet, cancel bet buttons and inventory div
    function update_buttons_to_bet(active_bet_div) {
        if (!active_bet_div) {
            active_bet_div = $('.teams-bet__label .bet-item.active');
        }
        let bet_type = active_bet_div.data('type');
        let bets_count = active_bet_div.data('bets_count');
        let status = active_bet_div.data('status');
        let is_classic_bet = !bet_type.includes(`live`);
        //для классических ставок:
        //кнопка плейс бет активна если  data-bets_count= 0 и data-status = 0 
        //если data-bets_count > 0  и data-status = 0  то активны кнопки отмены и апдейта ставки
        //для лайв ставок у нас кнопка создания ставки была активна все время, пока есть этот тип ставки, но может её можно скрывать, когда нельзя сделать ставку (замочек)
        let place_bet_button = $('#place-bet');
        let update_bet_button = $('#update-bet');
        let cancel_bet_button = $('#cancel-bet');
        let buttons_block = $('.button-block');
        let inventory_div = $('#inventory');
        let remove_items_button = $('.bet-content-cancel');
        let allow_live_cof_change_div = $('.total-check-grid');
        let items_in_bet_count = $('.in_bet:visible .pay__item input.item_checkbox_js').length
        if (is_classic_bet) {
            allow_live_cof_change_div.hide();
            if (status == 0) {
                //матч не стартанул
                buttons_block.show();
                inventory_div.show();
                if (items_in_bet_count != 0) {
                    remove_items_button.show();
                } else {
                    remove_items_button.hide();
                }

                if (bets_count == 0) {
                    //ставок нет
                    place_bet_button.show();
                    update_bet_button.hide();
                    cancel_bet_button.hide();
                } else if (bets_count > 0) {
                    //ставки есть
                    place_bet_button.hide();
                    update_bet_button.show();
                    cancel_bet_button.show();
                }
            } else {
                //матч стартанул
                buttons_block.hide();
                inventory_div.hide();
                remove_items_button.hide();
            }
        } else {
            //it's live bet, hide all classic bets buttons and show live bets buttons
            allow_live_cof_change_div.show();
            inventory_div.show();
            buttons_block.show();
            place_bet_button.show();
            update_bet_button.hide();
            cancel_bet_button.hide();
            if (items_in_bet_count != 0) {
                remove_items_button.show();
            } else {
                remove_items_button.hide();
            }
        }
        window.dispatchEvent(new Event('resize'));
    }


    //adding betcoins
    $('.button-block').on('input change', 'input.input-range', function () {
        var $betcoin_div = $('.in_bet:visible  .bet-content-coin');
        var $betcoin_span = $betcoin_div.find('span[data-betcoin]');
        var current_value = Number($betcoin_span.data('betcoin'));
        var added_value = Number($(this).val());
        if (!$(this).is(':visible')) {
            added_value = 0;
        }
        // if (Number($('input.bet-content__range_value:visible').val()) != $added_value) {
        //     $('input.bet-content__range_value:visible').val($added_value);
        // }
        var total_bet_value = Number(current_value + added_value);
        if (total_bet_value <= 0) {
            total_bet_value = 0;
            $betcoin_div.addClass('hidden');
        } else {
            $betcoin_div.removeClass('hidden');
        }
        $betcoin_span.html(toFixed(total_bet_value, 2));

        //главный инпут куда надо записать валуе
        $('input[name="user_betcoin"').val(added_value);

        countTotalAndProfit();
    });
    $('.button-block').on('focusout', 'input.input-range-value', function () {
        if ($(this).val() == '') {
            $(this).val(0);
        }
    });
    $('.button-block').on('focus', 'input.input-range-value', function () {
        if ($(this).val() == 0) {
            $(this).val('');
        }
    });

})(jQuery);
